import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css'; // 假设样式文件叫Footer.css

const Footer: React.FC = () => {
    return (
        <div className="footer">
            <Link to="/terms">Documents</Link>
            <Link to="/privacy">Support</Link>
        </div>
    );
};

export default Footer;

